import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
	<div className="not-found-page">
		<h1>Страница не найдена.</h1>
		<Link to="/">Вернуться назад</Link>
	</div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./components/NotFound.js